import React from "react"

import { useTranslations } from "@cirrus/core/i18n/provider"

import { FormTitle, SubmitButton } from "../../components"
import { useNavigationService } from "../../providers/NavigationService"

export const ResetPasswordConfirmSubmitted = () => {
  const { i18n } = useTranslations()
  const { navigate } = useNavigationService()

  return <>
    <FormTitle sx={{ marginBottom: "10px" }}>
      {i18n("Account.RestoreForgottenPassword:PasswordReset")}
    </FormTitle>
    <div>{i18n("Account.RestoreForgottenPassword:PasswordSuccessfullyChanged")}</div>
    <SubmitButton type="button"
                  label={i18n("Account.ForgottenPassword:BackToLogin")}
                  onClick={() => navigate("/login")}/>
  </>
}
